import React from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Box, Tabs, Tab } from "@mui/material";
import { useUser } from "../../contexts/UserContext";

const ManagersDashboardLayout = () => {
  const { user } = useUser();
  const navigate = useNavigate();
  const location = useLocation();

  const isFullAdmin = user?.roles?.some((r) => r.admin === true);
  const isPermissionsTab = location.pathname.endsWith("/permissions");

  const handleTabChange = (event, newValue) => {
    navigate(newValue === 1 ? "/ManagersDashboard/permissions" : "/ManagersDashboard");
  };

  return (
    <Box display="flex" flexDirection="column" gap={3} p={2}>
      <Tabs value={isPermissionsTab ? 1 : 0} onChange={handleTabChange} indicatorColor="primary">
        <Tab label="דשבורדים" />
        {isFullAdmin && <Tab label="הרשאות" />}
      </Tabs>

      <Outlet />
    </Box>
  );
};

export default ManagersDashboardLayout;
